import PropTypes from 'prop-types';
import { GECKO_CONSTS } from '../constants';

const GeckoLabelModel = {
  name: PropTypes.string.isRequired,
  type: PropTypes.oneOf([
    GECKO_CONSTS.LABEL_TYPE_DANGER,
    GECKO_CONSTS.LABEL_TYPE_DEFAULT,
    GECKO_CONSTS.LABEL_TYPE_PRIMARY,
    GECKO_CONSTS.LABEL_TYPE_INFO,
    GECKO_CONSTS.LABEL_TYPE_SUCCESS,
    GECKO_CONSTS.LABEL_TYPE_WARNING,
  ]),
};

export { GeckoLabelModel };

export default GeckoLabelModel;
